function create_dangerous_buildings_chart () {
    $("#dangerous_buildings_refilter_trig").click(function(){
        loader_asynchronous(function(){
            $(".dangerous_buildings_filter_title").html('全市');
			if ($("#dangerous_buildings_heatmap").hasClass("bg-primary")) {
				map.removeLayer(overlay_dataset["temp_map"])
			} else { map_redraw(undefined, undefined, undefined) }
			dangerous_buildings_bar({destroy: true});
			$('#type-disabled-alert, #location-disabled-alert').addClass('d-none')
			$('#dangerous_buildings_type_pie_chart, #dangerous_buildings_location_pie_chart').removeClass('d-none')
            map.setView([25.038169, 121.557588], 11);
            setTimeout(function(){
                map.panBy([-80, 0]);
            }, 1000);
        });
    });
	$("#dangerous_buildings_points").click(() => {
		if ($("#dangerous_buildings_points").hasClass("bg-primary")) return
		$("#dangerous_buildings_points").addClass("bg-primary")
		$("#dangerous_buildings_heatmap").removeClass("bg-primary")
		$("#ovarlay_list_filter").find("input").val("火災決策").keyup()
		$("#ovarlay_list tbody").find("tr").eq(1).click()
		$("#ovarlay_list tbody").find("tr").eq(2).click()
	})
	$("#dangerous_buildings_heatmap").click(() => {
		if ($("#dangerous_buildings_heatmap").hasClass("bg-primary")) return
		$("#dangerous_buildings_heatmap").addClass("bg-primary")
		$("#dangerous_buildings_points").removeClass("bg-primary")
		$("#ovarlay_list_filter").find("input").val("火災決策").keyup()
		$("#ovarlay_list tbody").find("tr").eq(1).click()
		$("#ovarlay_list tbody").find("tr").eq(2).click()
	})
	
	raw_data["dangerous_buildings"].features.forEach(el => {
		if (el.properties.struct_type == '其他' || el.properties.struct_type == null) {
			el.properties.struct_type = el.properties.struct_type_note
		}
		el.properties.struct_type ??= '其他'
	})
	const data = raw_data["dangerous_buildings"]
	
    dangerous_buildings_bar({destroy: false});

    function dangerous_buildings_bar(table_setting){
        var building_number = {}, 
			building_type = {},
			building_location = {},
			building_coor = {}, 
			each_row_data = [], each_row_data_export = [];
        if (table_setting.destroy) {
            var table = $('#dangerous_buildings_list').DataTable();
            table.destroy();
            $("#dangerous_buildings_list tbody").empty();
        };
		data.features.forEach(function(el){
			// buildings region stat
			if (building_number[el.properties.region] == undefined) {
				building_number[el.properties.region] = { sum: 0, type: {}, location: {} };
			}
			building_number[el.properties.region].sum += 1;
			// buildings type stat all 
			if (building_type[el.properties.struct_type] == undefined) {
				building_type[el.properties.struct_type] = 0;
			}            
			building_type[el.properties.struct_type] += 1;
			// buildings location stat all
			if (building_location[el.properties.location_category] == undefined) {
				building_location[el.properties.location_category] = 0;
			}            
			building_location[el.properties.location_category] += 1;
			
			// buildings type stat filtered by region
			if (building_number[el.properties.region].type[el.properties.struct_type] == undefined) {
				building_number[el.properties.region].type[el.properties.struct_type] = 0;
			}            
			building_number[el.properties.region].type[el.properties.struct_type] += 1;
			// buildings location stat filtered by region
			if (building_number[el.properties.region].location[el.properties.location_category] == undefined) {
				building_number[el.properties.region].location[el.properties.location_category] = 0;
			}            
			building_number[el.properties.region].location[el.properties.location_category] += 1;

			var lat = parseFloat(el.geometry.coordinates[1]);
			var lng = parseFloat(el.geometry.coordinates[0]);

			each_row_data.push([el.properties.region, el.properties.address.slice(6), 
				el.properties.location_name, el.properties.struct_type, el.properties.location_category]);
			each_row_data_export.push([el.properties.rescue_plan_id, el.properties.region, el.properties.address, 
				el.properties.location_name, el.properties.struct_type, el.properties.location_category, lat, lng]);
			// 點擊表格，找到地圖上的點位(座標提供)
			building_coor[el.properties.address.slice(6)] = [lat, lng];
		})

        // data processing
        var dangerous_buildings_sorted = Object.keys(building_number).sort((a, b) => 
			building_number[b].sum - building_number[a].sum);
		var chart_array = [], chart_array_name = []
        dangerous_buildings_sorted.forEach(function(el){
            chart_array.push(building_number[el].sum);
            chart_array_name.push(el.slice(0,2));
        });

        // pie
        dangerous_buildings_pie('type', building_type, undefined);
		dangerous_buildings_pie('location', building_location, undefined);
		$('#type-disabled-alert, #location-disabled-alert').addClass('d-none')
		$('#dangerous_buildings_type_pie_chart, #dangerous_buildings_location_pie_chart').removeClass('d-none')
		
        // chart
        Highcharts.chart('dangerous_buildings_bar_chart', {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: chart_array_name,
                labels: {
                    step: 1,
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)',
                        fontSize: '16px'
                    },
                    useHTML: true,
                    formatter: function(){
                        var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2)
                        return string;
                    }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)'
                    }                    
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)'
                    }
                }
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '<span style="color:{series.color};">{series.name}</span>: <b>{point.y}處</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false,
                        color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                    }
                },
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
							// 長條圖點擊事件(篩選行政區) >> 圓餅圖、表格、地圖點位連動
                            click: function () {
                                var filter_region = this.category + "區";
                                $(".dangerous_buildings_filter_title").html(filter_region)
                                // table
                                table_redraw_region(filter_region);
                                // chart
                                dangerous_buildings_pie('type', building_number[filter_region].type, filter_region);
								dangerous_buildings_pie('location', building_number[filter_region].location, filter_region);
								// map
								if (!$("#dangerous_buildings_heatmap").hasClass("bg-primary")) {
									map_redraw(undefined, filter_region, undefined)
								}
								// zoom-in
								region_focus(filter_region)
                            }
                        }
                    }
                }
            },
            series: [{
                name: '建築物數量',
                color: 'rgba(58, 197, 105, 1)',
                data: chart_array
            }]
        });

        // table
        $('#dangerous_buildings_list').DataTable({
            "data": each_row_data,
            "deferRender": true,
            "order": [[ 3, "desc" ]],
            "searching": true
        });
		// 點擊表格，找到地圖上的點位並zoom in
        $("#dangerous_buildings_list tbody").on("click", "tr", function(){
            var coor_array = building_coor[$(this).find("td").eq(1).html()];
            map.setView(coor_array, 20);
        });

        $("#dangerous_buildings_download").click(function(){
            each_row_data_export.unshift(["搶救計畫編號","行政區","地址","建物名稱","建物類型"]);
            downloadxlsx("高風險建築物.xlsx", ["災情列表"], [each_row_data_export]);
        });
    }
    function dangerous_buildings_pie(kind, data_input, current_region){
        var type_Sorted = Object.keys(data_input).sort(function(a,b){ return data_input[b]-data_input[a]});
        var chart_array_disatype = [];
        type_Sorted.forEach(function(el){
            chart_array_disatype.push({
                name: el, 
                y: data_input[el]
            })        
        })
        var pieColors = get_red_color_schema(Object.keys(data_input))
        Highcharts.chart(`dangerous_buildings_${kind}_pie_chart`, {
            chart: {
                type: 'pie',
            },
            title: {
                text: ''
            },
            tooltip: {
                useHTML: true,
                headerFormat: '<span class="h5">{point.key}</span><br>',
                pointFormat: '{series.name} <b>{point.percentage:.1f}%</b><br>數量： <b>{point.y}處</b>'
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    colors: pieColors,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        // format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
                        distance: -50,
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 4
                        },
                        style: {
                            fontWeight: 'bold',
                            fontSize:  '1rem'
                        },
                        formatter: function(){
                            var string;
                            string = '<span>' + this.key + '占' + this.percentage.toFixed(0) + "%<br>(" + this.y + "筆)</span>";
                            return string;
                        }
                    },
					showInLegend: true,
					size: '90%',
                },
                series: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function(){
                                switch(this["selected"]){
                                    case(undefined):
                                    case(false):
										// 避免兩個圓餅圖互相影響
										if (kind == 'type') {
											$('#dangerous_buildings_location_pie_chart').addClass('d-none')
											$('#location-disabled-alert').removeClass('d-none')
										} else if (kind == 'location') {
											$('#dangerous_buildings_type_pie_chart').addClass('d-none')
											$('#type-disabled-alert').removeClass('d-none')
										}						
										table_redraw_pie_selected(kind, current_region, this.name)
										if ($("#dangerous_buildings_heatmap").hasClass("bg-primary")) return
										map_redraw(kind, current_region, this.name)
										if (current_region) region_focus(current_region)
                                        break;
                                    case(true):
										if (kind == 'type') {
											$('#dangerous_buildings_location_pie_chart').removeClass('d-none')
											$('#location-disabled-alert').addClass('d-none')
										} else if (kind == 'location') {
											$('#dangerous_buildings_type_pie_chart').removeClass('d-none')
											$('#type-disabled-alert').addClass('d-none')
										}		
                                        table_redraw_pie_selected(kind, current_region, '');
										if ($("#dangerous_buildings_heatmap").hasClass("bg-primary")) return
                                        map_redraw(kind, current_region, undefined);
										if (current_region) region_focus(current_region)
										break;
                                }
                            }
                        }
                    }
                }
            },
            series: [{
                name: '比例：',
                data: chart_array_disatype
            }],
			legend: {
				align: 'right',
				verticalAlign: 'middle',
				layout: 'vertical'
			},
        })
    }

	var original_data = data.features.map(el => [ el.properties.region, el.properties.address.slice(6), 
		el.properties.location_name, el.properties.struct_type, el.properties.location_category ])
    function table_redraw_region(filter_region){
        let table = $('#dangerous_buildings_list').DataTable();
		let filtered_data = original_data.filter(el => el[0] == filter_region)
		table.clear().rows.add(filtered_data).draw()
    }
	function table_redraw_pie_selected(kind, current_region, filter_target) {
		let table = $('#dangerous_buildings_list').DataTable();
		let filtered_data = current_region ? original_data.filter(el => el[0] == current_region) : original_data
		if (kind == 'type' && filter_target !== '') {
			filtered_data = filtered_data.filter(el => el[el.length - 2] == filter_target)
		} else if (kind == 'location' && filter_target !== '') {
			filtered_data = filtered_data.filter(el => el[el.length - 1] == filter_target)
		}
		table.clear().rows.add(filtered_data).draw()
	}

    function map_redraw(kind, filter_region, filter_target){
		$("#map_clear").click();
		backgroud_layer_control("狹小巷道火災搶救不易地區");
        backgroud_layer_control("毒化物與其他化學品-點位圖");
		dangerous_buildings_filter['region'] = filter_region
		if (kind == 'type') {
			dangerous_buildings_filter['type'] = filter_target
		} else if (kind == 'location') {
			dangerous_buildings_filter['location'] = filter_target
		}
		backgroud_layer_control("高危險建築物-點位圖");
    }
	function region_focus(target) {
		var target_geojson;
		overlay_dataset["Basic_map"].features.forEach(function(el){
			if (el.properties.TOWNNAME == target) {
				target_geojson = el;
			}
		})
		if (overlay_dataset["temp_map"] != undefined) {
			map.removeLayer(overlay_dataset["temp_map"]);
		}
		overlay_dataset["temp_map"] = L.geoJson(target_geojson,{
			color: "blue",
			weight: 3,
			fill: false,
			interactive: false
		}).addTo(map);
		map.fitBounds(overlay_dataset["temp_map"].getBounds());
		setTimeout(function(){
			map.panBy([-90, 0]);
		}, 500);
	}
}